import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const isSettingsModalActive = (state: RootState): boolean => state.settingsModal.isActive;
